import { IErrorMessage } from '@hooks/use-error-message.ts';
import { DepartmentUnitType } from '@models/departments-and-units/units.model.ts';

export const unitsErrorMessages: IErrorMessage = {
  unitName: {
    required: 'validation_unit_name_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  assignedAdmin: {
    required: 'validation_assigned_admin_required'
  },
  type: {
    required: 'validation_unit_type_required'
  },
  description: {
    required: 'validation_description_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  }
};

export const UnitsStatusMap: Record<
  'true' | 'false',
  { text: string; color: string }
> = {
  true: {
    text: 'Active',
    color: 'var(--green-4)'
  },
  false: {
    text: 'Inactive',
    color: 'var(--pink)'
  }
};

export const unitsFilterStatusOptions = [
  { title: 'Active', value: true },
  { title: 'Inactive', value: false }
];

export const unitsTypeList = [
  { id: 1, title: DepartmentUnitType.BARS, value: DepartmentUnitType.BARS },
  { id: 2, title: DepartmentUnitType.SPA, value: DepartmentUnitType.SPA },
  {
    id: 3,
    title: DepartmentUnitType.BEAUTY_SALON,
    value: DepartmentUnitType.BEAUTY_SALON
  },
  { id: 4, title: DepartmentUnitType.SHOPS, value: DepartmentUnitType.SHOPS },
  {
    id: 5,
    title: DepartmentUnitType.TENNIS_COURT,
    value: DepartmentUnitType.TENNIS_COURT
  },
  {
    id: 6,
    title: DepartmentUnitType.RESTURANTS,
    value: DepartmentUnitType.RESTURANTS
  },
  {
    id: 7,
    title: DepartmentUnitType.ROOM_SERVICE,
    value: DepartmentUnitType.ROOM_SERVICE
  },
  {
    id: 8,
    title: DepartmentUnitType.TRANSPORT,
    value: DepartmentUnitType.TRANSPORT
  }
];

export const convertToSelectedDepartment = (
  updateUnitData: any | null
): { id: number; title: string; value: string }[] => {
  if (!updateUnitData || !updateUnitData.department) return [];

  const { id, name } = updateUnitData.department;

  return [
    {
      id,
      title: name,
      value: name
    }
  ];
};
